import { useCallback } from 'react';

const useTopicPickerTopicSelect = ({ onSelectTopic, onAfterSelect, setListsIds }) => {
  return useCallback(
    ({ topic }) => {
      if (!topic) return;
      if (onSelectTopic) {
        onSelectTopic(topic);
      }
      if (setListsIds) {
        setListsIds(topic.id);
      }
      if (onAfterSelect) {
        onAfterSelect(topic);
      }
    },
    [onSelectTopic, onAfterSelect, setListsIds]
  );
};

export default useTopicPickerTopicSelect;
